import { useDispatch } from 'react-redux';
import { useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { createStockRequest, getStockAvailability, getPrice } from '../redux/actions';
/**
 * The `useProduct` hook returns a set of functions for product-related operations.
 *
 * @example
 *
 * ```javascript
 * import { useProduct } from '@chordcommerce/react-autonomy'
 *
 * const NotifyWhenBackInStockButton = ({ email, product }) => {
 *   const { createStockRequest } = useProduct()
 *
 *   const onClick = () => createStockRequest({ email, product })
 *
 *   return <button onClick={onClick}>Notify</button>
 * }
 * ```
 *
 * @category Hook
 */
export function useProduct() {
  const dispatch = useDispatch();
  const actionDispatches = useMemo(() => bindActionCreators({
    createStockRequest,
    getStockAvailability,
    getPrice
  }, dispatch), [dispatch]);
  return actionDispatches;
}